export default __webpack_public_path__ + "static/media/ImageCard.0e8bb660.svg";